"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Hubs$HUB_MARKETING$H;

// Need this map because of the duplicate cms GA tags
var _default = (_Hubs$HUB_MARKETING$H = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_MARKETING, 'marketing'), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SALES, 'sales'), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SERVICE, 'service'), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.CMS, 'cms'), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_CMS, 'cms'), _Hubs$HUB_MARKETING$H);

exports.default = _default;
module.exports = exports.default;